import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.613 5.333a.4.4 0 0 0-.06-.113l-.08-.1a.667.667 0 0 0-1.126.34 1 1 0 0 0 0 .127.6.6 0 0 0 .053.26.667.667 0 0 0 1.087.213.7.7 0 0 0 .14-.213.7.7 0 0 0 .053-.26 1 1 0 0 0 0-.127.5.5 0 0 0-.067-.127M8 7.573a.667.667 0 0 0-.667.667v2a.667.667 0 1 0 1.334 0v-2A.667.667 0 0 0 8 7.573m5.087-5.14a.67.67 0 0 0-.56-.133 5.33 5.33 0 0 1-4.147-.847.67.67 0 0 0-.76 0 5.33 5.33 0 0 1-4.147.847.667.667 0 0 0-.806.653V7.92a6 6 0 0 0 2.513 4.887l2.433 1.733a.67.67 0 0 0 .774 0l2.433-1.733a6 6 0 0 0 2.513-4.887V2.953a.67.67 0 0 0-.246-.52M12 7.92a4.67 4.67 0 0 1-1.953 3.8L8 13.18l-2.047-1.46A4.67 4.67 0 0 1 4 7.92v-4.2a6.67 6.67 0 0 0 4-.927 6.67 6.67 0 0 0 4 .927z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })